export const API_GET_LIST_PRODUCT = "api/product/site/list";
export const API_GET_VIEW_PRODUCT = "api/product/site/detail";
export const API_DELETE_PRODUCT = "api/product/form/delete";
export const API_CREATE_PRODUCT = "api/product/form/create";
export const API_UPDATE_PRODUCT = "api/product/form/update";
export const API_GET_LIST_PROPERTY_GROUP = "api/product/site/property-group";
export const API_UPLOAD_IMAGE = "api/general/storage/upload";
export const API_DELETE_UPLOAD_IMAGE = "api/general/storage/delete";